<template>
  <div class="msg-container">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="less">
.msg-container {
  padding: 0 16px;
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  color: #ff5c5c;
  box-sizing: border-box;
  border-radius: 5px;
  overflow: hidden;
  background-color: rgba(255, 92, 92, 0.2);
}
</style>